// #region Imports
import React, { useState, useEffect } from 'react';
import './CaixaTable.scss';
import iconSearch from '../../../assets/lupa.svg';
import iconLook from '../../../assets/look.svg';
import iconTrash from '../../../assets/trash.svg';
import { formatCurrency, formatDateISO } from '../../../../shared/helpers';
// #endregion

export default function CaixaTable({
  loading = false,
  stats,
  filters,
  data = [],
  total = 0,
  page = 1,
  pageSize = 10,
  onFiltersChange = () => {},
  onPageChange = () => {},
  onCreate = () => {},
  onClose = () => {},
  onOpenMovimentos = () => {},
}) {
  // #region Estado (filtros draft)
  const [draft, setDraft] = useState(filters);

  useEffect(() => { setDraft(filters); }, [filters]);

  function updateDraft(patch) {
    setDraft(prev => ({ ...prev, ...patch }));
  }

  function apply() {
    onFiltersChange(draft);
  }

  function clear() {
    const cleared = { q: '', status: 'TODOS', periodo: 'TODOS' };
    setDraft(cleared);
    onFiltersChange(cleared);
  }
  // #endregion

  // #region Paginação
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  function jump(p) {
    const next = Math.min(Math.max(1, p), totalPages);
    onPageChange(next);
  }
  // #endregion

  // #region Render body
  function renderBody() {
    if (loading) {
      return Array.from({ length: 6 }).map((_, i) => (
        <tr key={'sk' + i} className="skeleton-row">
          <td colSpan="11">
            <div className="sk-line w40" />
            <div className="sk-line w25" />
          </td>
        </tr>
      ));
    }

    if (data.length === 0) {
      return (
        <>
          <tr>
            <td colSpan="11" className="empty-cell">Nenhum caixa encontrado.</td>
          </tr>
          {Array.from({ length: 5 }).map((_, i) => (
            <tr key={'filler-empty-' + i} className="row-filler">
              <td colSpan="11" />
            </tr>
          ))}
        </>
      );
    }

    return (
      <>
        {data.map(c => {
          const diferenca = (c.valor_real != null ? c.valor_real : c.valor_estimado) - c.valor_inicial;
            const diffPos = diferenca >= 0;
            return (
              <tr key={c.id}>
                <td>
                  <div className="cell-main">
                    <span className="cell-title">{formatDateISO(c.data_referencia)}</span>
                    <span className="cell-sub">ID: {c.id}</span>
                  </div>
                </td>
                <td>{c.data_abertura ? formatDateISO(c.data_abertura.substring(0, 10)) : '-'}</td>
                <td>{c.data_fechamento ? formatDateISO(c.data_fechamento.substring(0, 10)) : '-'}</td>
                <td>{formatCurrency(c.valor_inicial)}</td>
                <td>{formatCurrency(c.valor_estimado)}</td>
                <td>{c.valor_real != null ? formatCurrency(c.valor_real) : '-'}</td>
                <td>
                  <span className={`tag ${diffPos ? 'tag-success-outline' : 'tag-danger-outline'}`}>
                    {(diffPos ? '+' : '') + formatCurrency(diferenca).replace('R$', 'R$ ')}
                  </span>
                </td>
                <td>
                  <span className={`tag status-${c.status.toLowerCase()}`}>{c.status.replace('_', ' ')}</span>
                </td>
                <td className="actions">
                  <button
                    type="button"
                    className="icon-btn"
                    onClick={() => onOpenMovimentos(c.id)}
                    aria-label="Ver movimentos"
                    title="Ver movimentos"
                  >
                    <img src={iconLook} alt="" />
                  </button>
                  {c.status === 'ABERTO' && (
                    <button
                      type="button"
                      className="icon-btn danger"
                      onClick={() => onClose(c.id)}
                      aria-label="Fechar caixa"
                    >
                      <img src={iconTrash} alt="" />
                    </button>
                  )}
                </td>
              </tr>
            );
        })}
        {data.length < 6 && Array.from({ length: Math.max(0, 6 - data.length) }).map((_, i) => (
          <tr key={'f-' + i} className="row-filler">
            <td colSpan="11" />
          </tr>
        ))}
      </>
    );
  }
  // #endregion

  // #region Render
  return (
    <div className="caixa-module">
      <div className="caixa-head">
        <h2 className="caixa-title">Caixa</h2>
        <button type="button" className="btn btn-primary" onClick={onCreate}>
          <span className="btn-icon">+</span>
          {' '}Novo Caixa
        </button>
      </div>

      <div className="kpi-grid">
        <div className="kpi-card"><span className="kpi-label">Total</span><span className="kpi-value">{stats.total}</span></div>
        <div className="kpi-card"><span className="kpi-label">Abertos</span><span className="kpi-value kpi-success">{stats.abertos}</span></div>
        <div className="kpi-card"><span className="kpi-label">F. Manual</span><span className="kpi-value kpi-info">{stats.fechadosManual}</span></div>
        <div className="kpi-card"><span className="kpi-label">F. Auto</span><span className="kpi-value kpi-muted">{stats.fechadosAuto}</span></div>
        <div className="kpi-card"><span className="kpi-label">Entradas</span><span className="kpi-value kpi-warning">{formatCurrency(stats.totalEntradas)}</span></div>
        <div className="kpi-card"><span className="kpi-label">Saídas</span><span className="kpi-value kpi-danger">{formatCurrency(stats.totalSaidas)}</span></div>
        <div className="kpi-card"><span className="kpi-label">Saldo Atual</span><span className="kpi-value">{formatCurrency(stats.saldoAtual)}</span></div>
      </div>

      <div className="filter-panel">
        <div className="filter-header">
          <img src={iconSearch} alt="" className="filter-icon" />
          <span className="filter-title">Filtros</span>
        </div>
        <div className="filter-grid">
          <div className="filter-field">
            <label htmlFor="f-q">Buscar</label>
            <input
              id="f-q"
              placeholder="Data, ID ou observações"
              value={draft.q}
              onChange={e => updateDraft({ q: e.target.value })}
              disabled={loading}
            />
          </div>
          <div className="filter-field">
            <label htmlFor="f-status">Status</label>
            <select
              id="f-status"
              value={draft.status}
              onChange={e => updateDraft({ status: e.target.value })}
              disabled={loading}
            >
              <option value="TODOS">Todos</option>
              <option value="ABERTO">Aberto</option>
              <option value="FECHADO_MANUAL">Fechado Manual</option>
              <option value="FECHADO_AUTO">Fechado Auto</option>
            </select>
          </div>
          <div className="filter-field">
            <label htmlFor="f-periodo">Período</label>
            <select
              id="f-periodo"
              value={draft.periodo}
              onChange={e => updateDraft({ periodo: e.target.value })}
              disabled={loading}
            >
              <option value="TODOS">Todos</option>
              <option value="HOJE">Hoje</option>
              <option value="ULT_7">Últimos 7 dias</option>
              <option value="MES">Mês</option>
            </select>
          </div>
          <div className="filter-actions">
            <button type="button" className="btn btn-primary" onClick={apply} disabled={loading}>Filtrar</button>
            <button type="button" className="btn btn-ghost" onClick={clear} disabled={loading}>Limpar Filtros</button>
          </div>
        </div>
      </div>

      <div className="table-wrapper">
        <div className="table-container">
          <table className="ct-table">
            <thead>
              <tr>
                <th>Data</th>
                <th>Abertura</th>
                <th>Fechamento</th>
                <th>Inicial</th>
                <th>Estimado</th>
                <th>Real</th>
                <th>Diferença</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>{renderBody()}</tbody>
          </table>
        </div>
        <div className="ct-footer">
          <div className="result-count">Total: {total}</div>
          <div className="pagination">
            <button type="button" onClick={() => jump(1)} disabled={page === 1 || loading}>&laquo;</button>
            <button type="button" onClick={() => jump(page - 1)} disabled={page === 1 || loading}>&lsaquo;</button>
            <label className="page-jump">
              <input
                value={String(page)}
                onChange={e => {
                  const v = e.target.value.replace(/\D/g, '');
                  if (v) jump(Number(v));
                }}
                disabled={loading}
                inputMode="numeric"
              />
              <span className="total-pages">/ {totalPages}</span>
            </label>
            <button type="button" onClick={() => jump(page + 1)} disabled={page === totalPages || loading}>&rsaquo;</button>
            <button type="button" onClick={() => jump(totalPages)} disabled={page === totalPages || loading}>&raquo;</button>
          </div>
        </div>
      </div>
    </div>
  );
  // #endregion
}
